import './item-edit-menu.scss'

import { faCheck, faTabletAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import _ from 'lodash';
import { defineComponent } from 'vue'

import { OfflineDataFetcher } from '@skinsoft/offline'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

import { DELETE_MODIFICATIONS_NOT_SYNCHRONIZED, DELETE_NOT_SYNCHRONIZED_NEW_ITEM, SAVE_CURRENT_ITEM_TOPIC, TOGGLE_MENU_TOPIC } from '@skinsoft/bus';

export const ItemEditMenu = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: [''],
    template: require('./item-edit-menu.html'),
    data() {
        return {
            itemId: "",
            onLine: false,
            running: false,

            // Icons
            checkIcon: faCheck,
            crossIcon: faTimes,
            warningIcon: faTabletAlt,
        }
    },
    computed: {
        displayLocalWarning(): boolean | string {
            return !this.onLine || (this.itemId && OfflineDataFetcher.isTemporaryId(this.itemId));
        },

        isNewItemNotSynchronized(): boolean | string {
            return this.itemId && OfflineDataFetcher.isTemporaryId(this.itemId);
        },
    },
    mounted() {
        this.itemId = _.get(this.$route, 'params.itemId') as string;
    },
    created() {
        this.running = true;
        this.onFrame();
    },
    beforeUnmount() {
        this.running = false;
    },
    methods: {
        saveItem() {
            this.emitOnBus(SAVE_CURRENT_ITEM_TOPIC);
            this.emitOnBus(TOGGLE_MENU_TOPIC);
        },

        deleteNotSynchronizedNewItem() {
            this.emitOnBus(DELETE_NOT_SYNCHRONIZED_NEW_ITEM);
            this.emitOnBus(TOGGLE_MENU_TOPIC);
        },

        deleteModificationsNotSynchronized() {
            this.emitOnBus(DELETE_MODIFICATIONS_NOT_SYNCHRONIZED);
            this.emitOnBus(TOGGLE_MENU_TOPIC);
        },

        onFrame() {
            this.onLine = window.navigator.onLine;
            if (this.running) {
                requestAnimationFrame(this.onFrame);
            }
        },
    },
})
